import { render, staticRenderFns } from "./btn-new.vue?vue&type=template&id=c2af3cc4&scoped=true"
import script from "./btn-new.vue?vue&type=script&lang=js"
export * from "./btn-new.vue?vue&type=script&lang=js"
import style0 from "./btn-new.vue?vue&type=style&index=0&id=c2af3cc4&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2af3cc4",
  null
  
)

export default component.exports